require('./orientation.helper.scss');

import SVG from 'svg.js';

const mouse = require('./templates/mouse.html');
const hand = require('./templates/hand.html');

class OrientationHelper {
    _instance = null;
    _intervalPointer = null;
    _wrapper = null;
    _translate = null;
    _types = {
        mouse,
        hand
    };
    _animations = {};
    _options = {
        activeColor: '#777777',
        infinite: true,
        type: 'hand',
        wrapper: 'e3-orientation-helper',
        animationDuration: 4000,
        animationPause: 500,
        accessibility: true
    };

    constructor(container, opt = {}) {
        this._prepareOptions(opt);
        this._init(container);
    }

    _prepareOptions(opt) {
        Object.keys(opt).forEach((key) => {
            this._options[key] = opt[key];
        });

        this._animations = {
            mouse: this._mouseAnimation.bind(this),
            hand:  this._handAnimation.bind(this)
        }
    }

    _init(container) {
        let {type, wrapper, accessibility} = this._options;
        let elem = this._types[type];

        try {
            if (!elem) throw `Type < ${type} > does not support!`;
        } catch (e) {
            console.error(e);
            
            return e;
        }

        this._wrapper = document.createElement('div');
        if(accessibility){
            wrapper += ' accessibility';
        }
        this._wrapper.className = wrapper;
        this._wrapper.classList.add(`helper-${type}`);
        this._wrapper.innerHTML = elem;

        elem = this._wrapper.children[0];

        container.appendChild(this._wrapper);

        this._instance = SVG.adopt(elem);
    }

    _mouseAnimation() {
        let {activeColor, animationDuration: duration} = this._options;
        let mouse = this._instance.select('#mouse');
        let leftBtn = this._instance.select('#left-button');

        // Needed to avoid situations collision
        leftBtn.stop(false, true);
        mouse.stop(false, true);

        // animation duration divide on few steps
        // 1 + 2 + 4 + 2 + 1 = 10

        let step = duration / 10;

        leftBtn
            .animate(step, '-', 0).attr({fill: activeColor})
            .queue(() => {
                mouse.animate(2 * step, '-', 0).rotate(8, 270, 1000)
                    .animate(4 * step, '-', 0).rotate(-8, 270, 1000)
                    .animate(2 * step, '-', 0).rotate(0, 270, 1000)
                    .after(() => leftBtn.fx.dequeue())
            })
            .animate(step, '-', 0).fill('#ffffff');
    }

    _handAnimation() {
        let {activeColor, animationDuration: duration} = this._options;
        let hand = this._instance.select('#hand');
        let circle = this._instance.select('#circle');

        // Needed to avoid situations collision
        hand.stop(false, true);
        circle.stop(false, true);

        circle.attr({fill: activeColor});

        // animation duration divide on few steps
        // 2 + 1 + 3 + 6 + 3 + 1 + 2= 18

        let step = duration / 18;

        hand
            .animate(2 * step, '-', 0).translate(0, -10)
            .queue(() => {
                circle.animate(step, '-', 0).attr({opacity: 1})
                    .afterAll(() => hand.fx.dequeue())
            })
            .animate(3 * step, '-', 0).translate(-50, -10)
            .animate(6 * step, '-', 0).translate(50, -10)
            .animate(3 * step, '-', 0).translate(0, -10)
            .queue(() => {
                circle.animate(step, '-', 0).attr({opacity: 0})
                    .afterAll(() => hand.fx.dequeue())
            })
            .animate(2 * step, '-', 0).translate(0, 0);
    }

    get isShown() {
        return this._wrapper.classList.contains('show');
    }

    show() {
        this._wrapper.classList.add('show');
    }

    hide() {
        this.pause();
        this._wrapper.classList.remove('show');
    }

    play() {
        let {infinite, animationDuration, animationPause, type} = this._options;


        if (this._intervalPointer) this.pause();
        if (!this.isShown) this.show();

        if (infinite) {
            let duration = animationDuration + animationPause;
            this._animations[type]();
            this._intervalPointer = setInterval(this._animations[type].bind(this), duration);
        } else {
            this._animations[type]();
        }
    }

    pause() {
        let elem = this._instance.children()[0];

        if (this._intervalPointer) {
            clearInterval(this._intervalPointer);
            this._intervalPointer = null;
        }

        if (!elem) return;

        try {
            elem.pause();
        } catch (e) {
            console.error(e);
            // ... prevent error bubbling
        }
    }

    destroy() {
        if (this._intervalPointer)
            clearInterval(this._intervalPointer);
    }
}

export default OrientationHelper;
